import React, { Component } from "react";
import styles from "./trips.module.scss";
import { Circle, MapContainer, Marker, TileLayer } from "react-leaflet";
import { withMapControl } from "../../../shared/containers/containerMapControl";
import { ControlPointIcon } from "../ControlPoints/ControlPointIcon";
import L from "leaflet";

class TripControlPointVariationMap extends Component {
  render() {
    const { controlPoint, mapBaseLayer, height } = this.props;
    if (controlPoint === null) return null;

    const svgIcon = L.divIcon({
      html: `<div>${ControlPointIcon.getIcon("black")}</div>`,
      className: "svg-icon",
      iconSize: [26, 26],
      iconAnchor: [6, 25],
    });

    return (
      <div style={{ height: `${height}px`, position: "relative" }}>
        <MapContainer
          key={`${controlPoint.id}${controlPoint.radius}`}
          center={[controlPoint.latitude, controlPoint.longitude]}
          zoom={16}
          maxZoom={mapBaseLayer.maxZoom}
          minZoom={3}
          crs={mapBaseLayer.crs}
          zoomControl={true}
          attributionControl={false}
          doubleClickZoom={false}
          scrollWheelZoom={false}
          dragging={false}
          animate={true}
          easeLinearity={0.35}
          className={styles.mapWrapper}
          style={{ width: "100%" }}
        >
          {mapBaseLayer.url.map((_url, index) => {
            return <TileLayer key={mapBaseLayer.name + index} url={_url} updateWhenIdle={true} maxZoom={mapBaseLayer.maxZoom} />;
          })}

          <Marker draggable={false} icon={svgIcon} position={[controlPoint.latitude, controlPoint.longitude]}></Marker>

          {controlPoint.radius > 0 ? (
            <Circle
              key={`${controlPoint.radius} ${controlPoint.latitude} ${controlPoint.longitude} ${`${controlPoint.radius}`}`}
              center={[controlPoint.latitude, controlPoint.longitude]}
              radius={Number(controlPoint.radius)}
            />
          ) : null}

          {this.props.children}
        </MapContainer>
      </div>
    );
  }
}

export default withMapControl(React.memo(TripControlPointVariationMap));
